/** @jsxImportSource @emotion/react */
import React, { useContext, useEffect, useState } from "react";
import Slide from "@mui/material/Slide";
import AppBar from "../../components/AppBar";
import Avatar from "../../components/Avatar";
import Button from "../../components/Button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProgressBar from "../../components/ProgressBar";
import OfferCard from "../../components/OfferCard";
import moment from "moment";
import { UserContext } from "../../context/UserContext";
import { useGetNavItems } from "../Home/appbarNav";
import { useGetRewardsScreenStyles } from "./index.styles";
import Pagination from "../../components/Pagination";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { baseUrl } from "../../connections";
import { useCategory } from "../../hooks/services/useCategory";
import { useReward } from "../../hooks/services/useReward";
import { useRedeemhistory } from "../../hooks/services/useRedeemHistory";
import { useFavourites } from "../../hooks/services/useFavourites";
import useGetColors from "../../utils/colors";
import Footer1 from "../../components/Footer/Footer";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Grid, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import "./swalstyle.css";
import TabView from "../../components/Tabs";
import { styled } from "@mui/system";
import t from "../../theme";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  "& span": {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  "& span.bold": {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
}));

const MobileRewards = () => {
  const classes = useGetRewardsScreenStyles();
  const { offerCardMultiColors: colors } = useGetColors();
  const { userDetails } = useContext(UserContext);
  const {
    categoryList,
    point,
    isCatLoading,
    catError,
    totalCount,
    catDetails,
    defaultId,
    defaultName,
    setCatPayload,
    setCatDetailsPayload,
  } = useCategory();
  const { setUpdateMailFav } = useFavourites();
  const { rewards, setPayload, setStateChange1, stateChange1 } = useReward();
  const {
    rewardshistory,
    setPayloads,
    setpage,
    setlimit,
    setsearch,
    count,
    setStateChange,
    stateChange,
    page,
  } = useRedeemhistory();
  const [selCategory, setSelectCategory] = useState("");
  const [category, setCategory] = useState("");
  const [pageNUmber, setPageNumber] = useState(1);
  const [pageNUmber1, setPageNumber1] = useState(1);
  const [status, setstatus] = useState(false);
  const [status1, setstatus1] = useState(false);
  const [toast11, setoast11] = useState(false);

  const [message, setmessage] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  // const rewardNotify = searchParams.get('notify');
  const [rewardNotify, setNOtify] = useState(searchParams.get("notify"));

  useEffect(() => {
    setCatPayload("search=");
  }, [setCatPayload]);

  useEffect(() => {
    setPayload(`${userDetails?.uuid}`);
    setStateChange1(!stateChange1);
  }, [userDetails?.uuid, status1]);

  const pageChange = (pageN) => {
    setPageNumber1(pageN);
    setpage(pageN - 1);
  };
  useEffect(() => {
    setPayloads(`${rewards?.user_id}`);
    // setpage(`${pageNUmber1 - 1}`)
    setStateChange(!stateChange);
  }, [rewards?.user_id, status, pageNUmber1]);

  const Showhistory = () => {
    setPayloads(`${rewards?.user_id}`);
  };
  // rewards?.user_id
  useEffect(() => {
    // setTabindexs(0);
    setCatDetailsPayload(
      `user_uuid=${userDetails?.uuid}&category_uuid=${category ? category?.uuid : categoryList?.length > 0 ? categoryList[0]?.uuid : defaultId}&page=${pageNUmber - 1}&limit=10`,
    );
    setSelectCategory(selCategory ? selCategory : defaultName);
  }, [userDetails?.uuid, defaultId, pageNUmber, category]);

  const onCategoryHandle = (e, item) => {
    setCategory(item);
    setSelectCategory(item.name);
    setPageNumber(1);
    // setCatDetailsPayload(`user_uuid=${userDetails?.uuid}&category_uuid=${item?.uuid}&page=0&limit=10`);
  };

  const onFavouriteMailToggle = (e, mail_uuid) => {
    e.preventDefault();
    setUpdateMailFav({
      user_uuid: userDetails?.uuid,
      mail_uuid: mail_uuid,
    });
    setTimeout(() => {
      onCategoryHandle(e, category);
    }, 1000);
  };

  const searchfunction = (type, pages) => {
    if (type === "search") {
      setsearch(pages);
      setpage(0);
    }
    if (type === "prev") {
      setpage(page - 1);
    } else if (type === "next") {
      setpage(page + 1);
    } else if (type === "page") {
      setpage(page);
    } else if (type === "page+1") {
      setpage(page + 1);
    } else if (type === "page+2") {
      setpage(page + 2);
    } else if (type === "limit") {
      setlimit(pages);
      setpage(0);
    }
  };

  const [Availablepoints, setAvailablepoints] = useState("");
  const [Availablepoints1, setAvailablepoints1] = useState("");

  const Rewardsfunction = (data) => {
    Moneyredeempoints();
  };

  const Moneyredeempoints = () => {
    const points = Number(rewards?.point);
    if (!Number.isFinite(points)) {
      toast.error("Invalid points amount. Please refresh and try again.");
      return;
    }
    const payload = {
      user_uuid: rewards?.user_id,
      point: points,
    };
    axios
      .post(`${baseUrl}/point/redeemed/check`, payload)
      .then((res) => {
        Redeempointspopup(res?.data);
        // Redeempointssucess(res?.data)
        setAvailablepoints(res?.data);
        // setstatus(true)
      })
      .catch((err) => {
        // console.log(err, "dgdshs")
      });
  };
  const Moneyredeem = () => {
    const points = Number(rewards?.point);
    if (!Number.isFinite(points)) {
      toast.error("Invalid points amount. Please refresh and try again.");
      return;
    }
    const payload = {
      user_uuid: rewards?.user_id,
      point: points,
    };
    axios
      .post(`${baseUrl}/point/redeemed`, payload)
      .then((res) => {
        setAvailablepoints1(res?.data);
        setstatus(true);
        setstatus1(true);
        setoast11(true);
        setmessage("Redeemed Successfully !");
        toast.success(
          "points got Redeemed, Wait until You receive Message/Mail from Admi",
        );
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const Redeempointssucess = (data) => {
    Swal.fire({
      title: `Redeemed Successfully! `,
      // titletextcolor:'green',
      text: `${data?.redeemed_point}  points got Redeemed, Wait until you receive Message/Mail from Admin.`,

      confirmButtonColor: "green",
    }).then((result) => {
      if (result.isConfirmed) {
        // Moneyredeempoints()
      } else {
        // Back()
      }
    });
  };

  const Redeempointspopup = (AvailableP) => {
    Swal.fire({
      title: `Redeem Points : ${AvailableP?.redeemed_point}`,
      text: "Congratulations! You have accumulated enough points to redeem rewards. Click Redeem to claim your rewards now",
      showCancelButton: true,
      confirmButtonText: "Redeem",
      confirmButtonColor: "green",
      cancelButtonColor: "red",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      customClass: "swal",
    }).then((result) => {
      if (result.isConfirmed) {
        Moneyredeem();
        setTimeout(() => {
          Redeempointssucess(AvailableP);
        }, 1000);
        // Moneyredeempoints()
      } else {
        // Back()
      }
    });
  };
  const [data, setdata] = useState("");
  const [data1, setdata1] = useState("");

  useEffect(() => {
    rewardshistory?.map((items) => {
      return setdata(items);
    });
  }, [rewardshistory]);

  useEffect(() => {
    data?.history?.map((item) => {
      return setdata1(item);
    });
  }, [data]);

  const [open1, setOpen1] = useState(false);
  const [historyData, sethistoryData] = useState("");

  useEffect(() => {
    if (rewardNotify === "true") {
      setOpen1(true);
      setNOtify("false");
      setPayloads(`${userDetails?.uuid}`);
    }
  }, [rewardNotify, userDetails]);

  const handleClickOpen1 = (event) => {
    sethistoryData(event);
    setOpen1(true);
    // setStateChange1(!stateChange1)
    setStateChange(!stateChange);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };
  const navigate = useNavigate();

  const Back = () => {
    if (window?.location?.search === "?notify=true") {
      navigate("/home");
    } else {
      navigate(-1);
    }
  };
  const [tabIndexs, setTabindexs] = useState(0);
  return (
    <>
      <Dialog
        open={open1}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose1}
        fullScreen
        aria-describedby="alert-dialog-slide-description"
      >
        <div
          css={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "10px 12px",
            background: t.green.gradient,
            color: "#fff",
          }}
        >
          <IconButton
            aria-label="back"
            onClick={handleClose1}
            css={{ color: "#fff" }}
          >
            <ArrowBackIosIcon sx={{ fontSize: "1rem" }} />
          </IconButton>
          <h1 css={{ margin: 0, fontSize: "1.05rem", fontWeight: 700 }}>
            Redeem History
          </h1>
        </div>
        <DialogContent css={{ padding: "12px 12px 20px" }}>
          <div
            css={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            {rewardshistory?.length === 0 && (
              <p css={{ textAlign: "center", color: t.text.muted }}>
                No redemption history yet.
              </p>
            )}
            {rewardshistory?.map((item, index) => (
              <div
                key={item?.uuid || index}
                css={{
                  borderRadius: "14px",
                  padding: "12px 14px",
                  background: t.glass.light,
                  backdropFilter: t.blur.light,
                  WebkitBackdropFilter: t.blur.light,
                  border: t.border.subtle,
                  boxShadow: t.shadow.xs,
                }}
              >
                <div
                  css={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 6,
                  }}
                >
                  <span css={{ fontWeight: 700, color: t.green.dark, fontSize: "1rem" }}>
                    {item?.point} Points
                  </span>
                  <span
                    css={{
                      fontSize: "0.72rem",
                      fontWeight: 700,
                      textTransform: "capitalize",
                      padding: "2px 10px",
                      borderRadius: 999,
                      background: t.green.bg,
                      color: t.green.dark,
                    }}
                  >
                    {item?.status}
                  </span>
                </div>
                <div css={{ fontSize: "0.78rem", color: t.text.muted, marginBottom: item?.comment ? 4 : 0 }}>
                  {moment(item.createdAt).format("MMM D, YYYY")}
                </div>
                {item?.comment && (
                  <div css={{ fontSize: "0.8rem", color: t.text.secondary }}>
                    {item.comment}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div css={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
            <Pagination
              className="pagination-bar"
              currentPage={pageNUmber1}
              totalCount={count}
              pageSize={10}
              onPageChange={(page) => pageChange(page)}
            />
          </div>
        </DialogContent>
      </Dialog>

      <div css={classes.pageContainer}>
        <AppBar navItems={useGetNavItems({}).navItems} pageTitle="My Rewards" />
        <div css={classes.detailsWrapper}>
          <div css={classes.header}>
            <Avatar src={userDetails?.avatar} flatStyle rounded />
            <div css={classes.progressWrapper}>
              <div css={classes.userTypeTitle}>Premium User</div>
              <div css={classes.progressBarTitle}>My Status</div>
              {userDetails?.rewards?.point && (
                <ProgressBar
                  progress={rewards?.point}
                  progress11={rewards?.max_point}
                />
              )}
            </div>
            <div css={classes.balanceDetails}>
              <span css={classes.balanceDetailsTextLight}>
                <span>Total Points</span>
              </span>
              <span css={classes.balanceDetailsTextStrong}>
                {status === true
                  ? Availablepoints1?.available_point
                  : rewards?.point}{" "}
                points
              </span>
              <span css={classes.balanceDetailsTextLight}>
                <span>1000 Points = 1 Dollar</span>
              </span>
            </div>
            <div css={classes.headerActions}>
              {rewards?.point >= 1000 ? (
                <Button
                  variant="contained"
                  css={classes.redeemBtn}
                  onClick={() => Rewardsfunction(rewards)}
                >
                  Redeem now
                </Button>
              ) : (
                <Button variant="contained" css={classes.noredeemBtn}>
                  Redeem now
                </Button>
              )}
              <Button
                variant="contained"
                css={classes.redeemBtn}
                onClick={() => handleClickOpen1(rewardshistory)}
              >
                History
              </Button>
            </div>
            {rewards?.point < 1000 && (
              <p
                css={{
                  margin: "6px 0 0",
                  fontSize: "0.72rem",
                  color: t.text.muted,
                }}
              >
                Earn {1000 - (rewards?.point || 0)} more points to redeem.
              </p>
            )}
          </div>
          <div css={classes.accordionWrapper}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="h6">How to earn points</Typography>
              </AccordionSummary>
              <CustomAccordionDetails>
                <Typography variant="body1">
                  <span className="bold">View Paid Mails:</span>
                  <span>
                    Regularly check your portal for paid mails sent by Money
                    Mails.
                  </span>
                  <span className="bold">Open and Interact:</span>
                  <span>
                    Open these paid mails and follow any instructions, such as
                    clicking on a link, watching a video, or completing.
                  </span>
                  <span className="bold">Accumulate Points:</span>
                  <span>
                    Each paid mail interaction will earn you reward points.
                  </span>
                </Typography>
              </CustomAccordionDetails>
            </Accordion>
            {/* <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Shop on star money bonus day</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion> */}
          </div>
          <TabView
            tabs={categoryList}
            onTabChane={(uuid, idx) => onCategoryHandle(uuid, categoryList[idx])}
            subUuid={selCategory}
            setTabindexs={setTabindexs}
            tabIndex={tabIndexs}
            variant="pills"
            renderActiveTabContent={() => (
              <>
                <div css={classes.categoryView}>
                  <Grid container spacing={2}>
                    {catDetails &&
                      catDetails.map((_item, idx) => {
                        const item = {
                          subject: _item?.mails[0]?.subject,
                          mime_type: _item?.mails[0]?.mime_type,
                          brand: _item?.brand,
                          type: _item?.mails[0]?.type,
                        };
                        let j = idx % 4;
                        return (
                          <Grid spacing={4} xs={6} sm={6}>
                            <OfferCard
                              mobile={true}
                              key={_item?.uuid || idx}
                              isRedeemed={true}
                              containerStyles={{
                                backgroundColor: colors[j],
                                margin: 5,
                              }}
                              maxSize={"98%"}
                              size={"100%"}
                              height={200}
                              maxHeight={200}
                              onFavouriteMailToggle={(e) =>
                                onFavouriteMailToggle(e, _item?.uuid)
                              }
                              item={item}
                              isFavourite={_item?.mails[0]?.is_favourite}
                              message={_item?.mails[0]?.message || ""}
                            />
                          </Grid>
                        );
                      })}
                  </Grid>
                </div>
                <Pagination
                  className="pagination-bar"
                  currentPage={pageNUmber}
                  totalCount={totalCount}
                  pageSize={10}
                  onPageChange={(page) => setPageNumber(page)}
                />
              </>
            )}
          />
        </div>

        <Footer1 />
      </div>
    </>
  );
};

export default MobileRewards;
